module.exports = __webpack_public_path__ + "static/media/arrow_up_grey.0be7bc91.svg";